import styled from 'styled-components';
import Colors from 'assets/Colors';
import Constants from 'helpers/constants';

const ProfileWrapperSideBar = styled.div`
  margin-bottom: 13px;
  margin-left: 18px;
  @media (min-width: ${Constants.pxBreakPointNext}px) {
    display: none;
  }
`;

const Separator = styled.hr`
  margin: 0;
  border: 0;
  border-top: 1px solid ${Colors.line_separator};
  padding: 0;
`;

export default {
  ProfileWrapperSideBar,
  Separator,
};
